export default __webpack_public_path__ + "static/WebSite_3DShowcaseCookplay_VideoQHD-bdcbc913c0367ebd5be84d267915042c.mp4";